import { LESSON_STATUS } from '@yandex-int/k-common';

import { SPEC_COURSE_LESSON_STATUS } from 'common.components/spec-course/typings';

const mapper = {
    [LESSON_STATUS.ASSIGNED]: SPEC_COURSE_LESSON_STATUS.IN_PROGRESS,
    [LESSON_STATUS.IN_PROGRESS]: SPEC_COURSE_LESSON_STATUS.IN_PROGRESS,
    [LESSON_STATUS.WAIT_FOR_RESULTS]: SPEC_COURSE_LESSON_STATUS.WAITING_FOR_RESULTS,
    [LESSON_STATUS.NOT_ASSIGNED]: SPEC_COURSE_LESSON_STATUS.NOT_STARTED,
    [LESSON_STATUS.ASSIGNED_IN_FUTURE]: SPEC_COURSE_LESSON_STATUS.NOT_STARTED,
    [LESSON_STATUS.FINISHED]: SPEC_COURSE_LESSON_STATUS.FINISHED,
    [LESSON_STATUS.FINISH_FORCED]: SPEC_COURSE_LESSON_STATUS.FINISHED,
    [LESSON_STATUS.NOT_SOLVED]: SPEC_COURSE_LESSON_STATUS.FINISHED,
    [LESSON_STATUS.CANCELLED]: SPEC_COURSE_LESSON_STATUS.FINISHED,
};

export const getSpecCourseLessonStatus = (status: LESSON_STATUS | null): SPEC_COURSE_LESSON_STATUS => {
    if (!status) {
        return SPEC_COURSE_LESSON_STATUS.NOT_STARTED;
    }
    return mapper[status];
};
